export default {"src":"/_next/static/media/finance.1c4b2eb2.svg","height":150,"width":150,"blurWidth":0,"blurHeight":0};